/**
 * Tests if the current page is within an iFrame
 */
export const isPageInIFrame = () => {
    return window.location !== window.parent.location;
};
